import BaseService from "./base.service";

class UserExamsService extends BaseService {
  get entity() {
    return "exams";
  }

  getMyExams() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`me/exams?include=certification`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  addExam(exam_date, exam_time, certification_id) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`me/exams`, {
          exam_date: exam_date.split(" ")[0],
          exam_time,
          certification_id,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  updateExam(exam_date, exam_time, score, approved, id) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .patch(`me/exams/${id}`, {
          exam_date: exam_date.split(" ")[0],
          exam_time,
          id,
          score,
          approved,
          finished_at: score != null ? new Date() : null,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  deleteExam(id) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .delete(`me/exams/${id}`, {
          id,
        })
        .then(resolve)
        .catch(reject);
    });
  }
  finishExam(id, score, result) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .patch(`me/exams/${id}`, {
          id,
          approved: result === "Aprovado!",
          score,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}

export default new UserExamsService();
